<template>
  <div class="error-page">
    <div class="error-page__content">
      <h1>404</h1>
      <div class="error-page__title">Page not found</div>
      <div class="error-page__text">
        Possibly, the page address may not be correct, or it has been moved. Please try to start with homepage.
      </div>
      <router-link to="/dashboard" class="error-page__actions">
        <button class="primary large">Back to dashboard</button>
      </router-link>
    </div>
    <img class="error-page__ill" src="@/assets/photos/err404.svg" alt="" />
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
}
</script>

<style lang="scss">
.error-page {
  h1 {
    font-weight: 700;
    font-size: 40px;
    line-height: 116%;
  }

  &__title {
    font-weight: 700;
    font-size: 24px;
    line-height: 116%;
    margin-bottom: 15px;
  }

  &__content {
    max-width: 220px;

    @include mobile {
      margin-bottom: 60px;
    }
  }

  &__actions {
    display: inline-block;
    margin-top: 30px;
  }

  &__ill {
    @include PC {
      margin-top: 20vh;
    }

    @include mobile {
      order: -1;
      min-height: 200px;
      max-width: 80vw;
      margin-top: 30px;
      margin-bottom: 50px;
    }
  }
}

#content.error-page {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 1000px;
  padding: 0 110px;
  height: 100vh;

  @include mobile {
    flex-direction: column;
    justify-content: flex-start;
    min-width: unset;
    padding: 40px 25px;
  }
}
</style>
